import { countryHasActiveSubscriptionType, findCountryFromDwKey } from '@sr/utils';
import { useProfile } from 'core/lib/Profile';

const useSubscriptionsPartners = () => {
  const [profile, loadingProfile] = useProfile();

  if (!profile || loadingProfile) {
    return { partners: undefined, loading: loadingProfile };
  }

  const allPartners =
    profile.permissions?.businessPartners
      .filter((bp) => {
        const country = findCountryFromDwKey(bp.id);
        const businessPartnerCanChooseSubscription =
          country !== undefined && countryHasActiveSubscriptionType(country);

        return businessPartnerCanChooseSubscription || profile.permissions?.superUser;
      })
      .map((obj) => obj.id) ?? [];

  return { partners: allPartners.length ? allPartners : undefined, loading: loadingProfile };
};

export default useSubscriptionsPartners;
